var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      ref: "card",
      staticClass: "rounded-lg d-flex flex-column flex-grow-1",
      attrs: { elevation: "6", "max-height": "500px" },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-title",
        [
          _c("v-icon", { attrs: { left: "" } }, [
            _vm._v("mdi-account-box-multiple-outline"),
          ]),
          _vm._v(" " + _vm._s(_vm.$t("presencelist")) + " "),
        ],
        1
      ),
      _c(
        "v-card-text",
        { ref: "cardText", staticClass: "flex-grow-1" },
        [
          _c(
            "v-container",
            { staticClass: "pr-0 d-flex flex-wrap" },
            _vm._l(_vm.presenceListUsers, function (user) {
              return _c(
                "div",
                { key: user.sapEmpId, staticClass: "px-4 mb-2" },
                [
                  _c(
                    "v-card",
                    {
                      style: `border-bottom: 5px solid ${user.color} !important;`,
                      attrs: {
                        width: 200,
                        height: 50,
                        rounded: "r-xl",
                        flat: "",
                        color: _vm.$vuetify.theme.dark
                          ? "#323131"
                          : "grey lighten-3",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-row" },
                        [
                          _c("v-img", {
                            attrs: {
                              "min-width": 50,
                              "max-width": 50,
                              "min-height": 50,
                              "max-height": 50,
                              src: user.profilePicture,
                            },
                          }),
                          _c(
                            "div",
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "pt-0 pl-2 pb-0" },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "name-ellipsis",
                                                      },
                                                      "span",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [_vm._v(_vm._s(user.name))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v(_vm._s(user.name))])]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        { attrs: { align: "end" } },
        [
          _c(
            "v-row",
            { staticClass: "px-6 pb-6", attrs: { justify: "end" } },
            [
              this.$store.getters["user/user"].userGroupRights
                .canAccessPresenceList
                ? _c(
                    "v-btn",
                    {
                      staticStyle: { color: "white" },
                      attrs: { rounded: "", color: "#990000" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push("PresenceList")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("showAll")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }